<template>
  <div class="aboutContainer">
    <p class="abouttitle">OUR VISION</p>
    <p class="aboutvision">Vision & mission statement that wraps to second line.</p>
    <div class="triangleBack"></div>
    <div class="rectangleBack"></div>
  </div>
</template>

<script>
import {mapState,mapMutations} from 'vuex'
export default {
  name: 'top',
  data () {
    return {
      msg: '',
      lang:'zh-CN',
    }
  },
  mounted: function () {
    this.$nextTick(function () {
      
    })
  },
  computed: {
    
  },
  methods: {
    
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scope>
.aboutContainer{
    padding: 0;
    margin-top:40px;
}
.aboutContainer .abouttitle{margin-top:217px;margin-left:126px;width: 164px;
  height: 32px;
  font-family: Montserrat;
  font-style: normal;
  font-weight: 600;
  font-size: 26px;
  line-height: 32px;
  color: #AFAFAF;
  text-align:left;
}
.aboutContainer .aboutvision{margin-top:32px;margin-left:126px;
  width: 754px;
  height: 118px;
  font-family: Montserrat;
  font-style: normal;
  font-weight: 500;
  font-size: 48px;
  line-height: 59px;
  color: #000000;
  text-align:left;
}
.aboutContainer .triangleBack{
  width: 0;
  height: 0;
  background: #F8F8F8;
  border-bottom: 300px solid #F8F8F8;
  border-left: 100vw solid #fff;
}
.aboutContainer .rectangleBack{
  width: 100%;
  height: 1270px;
  background: #F8F8F8;
}
</style>




// WEBPACK FOOTER //
// src/components/About.vue